import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import cx from 'classnames';

interface SectionLinkProps {
    activeSectionId?: string;
    id: string;
    label: string;
}

export const SectionLink = ({
    activeSectionId,
    id,
    label,
}: SectionLinkProps): JSX.Element => {
    const isActiveLink = id === activeSectionId;
    const location = useLocation();

    return (
        <div className="mx-8 flex flex-col justify-between">
            <Link
                to={{
                    pathname: location.pathname,
                    search: location.search,
                    hash: id,
                }}
                aria-label={`Scroll to ${label}`}
                className={cx('text-sm font-semibold tracking-wider mb-1', {
                    'text-primary-500': isActiveLink,
                    'text-tertiary-400': !isActiveLink,
                })}
            >
                {label}
            </Link>
            <div
                className={cx({
                    'border-solid border-b-4 border-primary-500 rounded-full':
                        isActiveLink,
                })}
            />
        </div>
    );
};
